// extracted by mini-css-extract-plugin
module.exports = {"theme_chat_btn":"theme-settings_theme_chat_btn__31JIH"};